/**
 * The one place an @ is stripped on the client.
 *
 * Handles are stored bare — no leading @, no URL. The @ is presentation only.
 * This mirrors what create-extras-checkout does server-side, so what the buyer
 * sees in the field is exactly what gets stored.
 */

/** Strip @, whitespace and any pasted profile URL down to the bare handle. */
export function cleanHandle(raw: string | null | undefined): string | null {
  let v = (raw ?? "").trim();
  if (!v) return null;

  // Full or partial profile URL → the handle segment.
  const urlish = v.replace(/^https?:\/\//i, "").replace(/^www\./i, "");
  if (/^(instagram\.com|instagr\.am|x\.com|twitter\.com)\//i.test(urlish)) {
    v = urlish.split("?")[0].split("#")[0].split("/").filter(Boolean).slice(1)[0] ?? "";
  }

  v = v.replace(/^@+/, "").trim();
  return v || null;
}

/** Same rule, but always a string — for controlled inputs. */
export function cleanHandleInput(raw: string | null | undefined): string {
  return cleanHandle(raw) ?? "";
}

/** A handle is valid once it has no @ left and no internal whitespace. */
export function isValidHandle(input: string | null | undefined): boolean {
  const v = cleanHandle(input);
  return !!v && !v.includes("@") && !/\s/.test(v);
}

/** Render for display — adds the @. Older rows may already carry one. */
export function displayHandle(stored: string | null | undefined): string {
  const v = (stored ?? "").trim();
  if (!v) return "";
  return v.startsWith("@") ? v : `@${v}`;
}
